import { mutator } from 'satcheljs';
import { default as addAccount } from '../actions/addAccount';
import { default as getAccountBySourceId } from '../selectors/getAccountBySourceId';
import getAccountSourceListStore from '../store/accountSourceListStore';
import { updateMailboxInfo } from '../utils/updateMailboxInfo';

export default mutator(addAccount, actionMessage => {
    const store = getAccountSourceListStore();
    const existing = getAccountBySourceId(actionMessage.accountSource.sourceId);
    if (!existing) {
        updateMailboxInfo(actionMessage.accountSource);
        store.sources.push(actionMessage.accountSource);
        if (!store.selectedSourceId) {
            store.selectedSourceId = actionMessage.accountSource.sourceId;
        }

        if (!store.globalSettingsSourceId) {
            store.globalSettingsSourceId = actionMessage.accountSource.sourceId;
        }
    } else {
        throw new Error('Found duplicated account in the store.');
    }
});
